import {
  chakra,
  forwardRef,
  type TableHeadProps as ChakraTheadProps,
} from '@chakra-ui/react';

import { useTableStyles } from '../TableStylesContext';

export type TheadProps = ChakraTheadProps;

export const Thead = forwardRef<TheadProps, 'thead'>((props, ref) => {
  const { thead: theadStyles } = useTableStyles() ?? {};

  return <chakra.thead {...props} ref={ref} __css={theadStyles} />;
});
